import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-any2any-logo',
  templateUrl: './any2any-logo.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: inline; }'],
  standalone: true
})
export class Any2anyLogoComponent {

  @Input() @HostBinding('style.height.px') public heightPx = 50;

  @HostBinding('style.width.px')
  private get widthPx(): number {
    // 184px x 50px
    return Math.round(3.68 * this.heightPx);
  }

}
